import React from 'react'
import useLearningResources from '../../../hooks/use-learning-resources'
import useLearningResourcesFilters from '../../../hooks/use-learning-resources-filters'
import { Row, Col, Spinner } from 'react-bootstrap'
import RecordPagination from '../../common/pagination'

const LearningResourcesPaginated = ({
    pageSize = 18,
    itemComponent
}) => {
    const {
        isLoading,
        learningResources,
        total
    } = useLearningResources({ limit: pageSize })
    const { offset, updateFilters } = useLearningResourcesFilters()
    const ItemComponent = itemComponent
    return (
        <React.Fragment>
            <Row>
                <Col className='text-center'>
                    &nbsp;{isLoading && <Spinner animation="border" size="sm" />}&nbsp;
                </Col>
            </Row>
            <Row noGutters>
                {learningResources.map( u => <ItemComponent key={u.id} resource={u}/>)}
                {!isLoading && !total && <Col className='text-muted text-center'>None found.</Col>}
            </Row>
            <Row>
                <Col>
                    <RecordPagination
                        offset={offset}
                        limit={pageSize}
                        total={total}
                        setOffset={offset => updateFilters({ offset })}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default LearningResourcesPaginated